<template>
  <div
    class="good_detail"
    v-loading="spuLoading"
    element-loading-text="拼命加载中"
  >
    <div class="detail_content home_page" v-if="spuInfo && spuInfo.spuId">
      <!-- 商品spu或sku信息显示 -->
      <div class="good_spku_info">
        <div class="good_info_imgs flex-shrink">
          <img
            v-if="
              currentSkuInfo &&
                currentSkuInfo.fileUrlList &&
                currentSkuInfo.fileUrlList.length &&
                currentSkuInfo.fileUrlList[mainGraphIndex]
            "
            :src="
              currentSkuInfo &&
                currentSkuInfo.fileUrlList &&
                currentSkuInfo.fileUrlList.length &&
                currentSkuInfo.fileUrlList[mainGraphIndex]
            "
            alt=""
            width="400px"
            height="400px"
          />
          <img
            v-else
            src="@/assets/img/bitmap.png"
            alt=""
            width="400px"
            height="400px"
          />
          <!-- 图片轮播图 -->
          <div
            class="img-carousel"
            v-show="
              currentSkuInfo &&
                currentSkuInfo.fileUrlList &&
                currentSkuInfo.fileUrlList.length
            "
          >
            <el-carousel
              indicator-position="none"
              height="60px"
              v-if="currentSkuInfo && currentSkuInfo.fileUrlList"
            >
              <el-carousel-item
                v-for="(i, ind) in Math.ceil(
                  currentSkuInfo.fileUrlList.length / 5
                )"
                :key="ind"
              >
                <div class="imgs-row">
                  <img
                    :src="item"
                    alt="商品主图"
                    width="60px"
                    height="60px"
                    v-for="(item, index) in currentSkuInfo.fileUrlList.slice(
                      ind * 5,
                      ind * 5 + 5
                    )"
                    :key="index"
                    @click="changeShowImg(ind * 5 + index)"
                    class="img_left"
                  />
                </div>
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
        <div class="good_info_content flex-grow">
          <div class="good_spku_info">
            <div class="flex-grow">
              <!-- sku 标题-->
              <div class="good_title line-break">
                {{currentSkuInfo.title}}
              </div>
              <div class="good_dec line-break">
                {{spuInfo.subtitle}}
              </div>
              <!-- 价格 -->
              <div class="good-flex good_original_price">
                <label class="lable flex-shrink">
                  价格
                </label>
                <div class="flex-grow original_price">
                  <good-price :price="currentSkuInfo.channelPrice"></good-price>
                  <span class="cross_price" v-if="currentSkuInfo.tagPrice">￥{{currentSkuInfo.tagPrice}}</span>
                  <span class="cross_price" v-else>￥{{currentSkuInfo.sellingPrice}} </span>
                </div>
              </div>
            </div>
            <div class="good_brand flex-shrink" v-show="spuInfo.brandLogoInfo">
              <img
                :src="spuInfo.brandLogoInfo.fileUrl"
                :alt="spuInfo.brandLogoInfo.name"
                class="cursor-pointer"
                @click="brandHandle(spuInfo.brandLogoInfo.brandId)"
                height="90px"
              />
              <div class="text-center">{{ spuInfo.brandLogoInfo.name }}</div>
            </div>
          </div>
          <div class="good-flex">
            <label class="lable flex-shrink">运费</label>
            <div class="flex-grow good-models">
              {{ spuInfo.userLabel || '' }}
            </div>
          </div>
          <div class="good-flex">
            <label class="lable flex-shrink">型号</label>
            <div class="flex-grow good-models">
              <div
                class="good-model"
                v-for="item in skuInfoList"
                :key="item.skuId"
                :class="{
                  'good-model-choosed': item.skuId == currentSkuInfo.skuId
                }"
                @click="changeCurrentSku(item)"
              >
                {{ item.model }}
              </div>
            </div>
          </div>
          <div class="good-flex">
            <label class="lable flex-shrink">数量</label>
            <div class="flex-grow">
              <el-input-number
                size="small"
                :disabled="loading"
                v-model="count"
                :min="1"
                :max="currentSkuInfo.inventoryQuantity || 999999999"
                :precision="0"
              ></el-input-number>
            </div>
          </div>
          <div class="good-flex" v-show="currentSkuInfo.skuCode">
            <label class="lable flex-shrink">商品编码</label>
            <div class="flex-grow good-models">
              {{ currentSkuInfo.skuCode }}
            </div>
          </div>
          <div class="good-flex" v-show="spuInfo">
            <label class="lable flex-shrink">商品货号</label>
            <div class="flex-grow good-models">
              {{ spuInfo.supplyCommodityCode }}
            </div>
          </div>
          <!-- 按钮组 -->
          <div class="bottom">
            <div>
              <div class="good-opt">
                <el-button
                  class="buy-imm but_ban"
                  v-if="currentSkuInfo.inventoryQuantity <= 0"
                  :loading="loading"
                  >已售光</el-button
                >
                <el-button
                  class="buy-imm"
                  @click="buySku"
                  v-else
                  :loading="loading"
                  >立即购买</el-button
                >
                <el-button
                  class="add-cart"
                  @click="addCart('5')"
                  :loading="loading"
                  >加入购物车</el-button
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 商品详情相关信息 -->
      <div class="good_spku_info">
        <el-tabs type="border-card" style="width: 100%">
          <el-tab-pane>
            <span slot="label">商品详情</span>
            <div
              v-html="spuDetailInfo"
              class="line-break good_spu_detail"
            ></div>
          </el-tab-pane>
          <el-tab-pane>
            <span slot="label">商品参数</span>
            <div
              v-for="optionItem in attributeGroupList"
              :key="optionItem.attributeGroupId"
              class="group_params"
            >
              <div class="model_params_name">
                {{ optionItem.name }}
              </div>
              <div
                v-for="attItem in optionItem.attributeItemList"
                :key="attItem.attributeItemId"
                class="attList"
              >
                <div class="att-name">{{ attItem.name }}</div>
                <div class="att-value">
                  {{ attItem.attributeValueList | formatAtt }}
                </div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane>
            <span slot="label">商品手册</span>
            <div
              v-if="currentSkuInfo && currentSkuInfo.manualFile"
              @click="viewAttachment(currentSkuInfo.manualFile.fileUrl)"
              class="attachment"
            >
              {{ currentSkuInfo.manualFile.fileName || currentSkuInfo.title }}
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <div class="home_page" v-else>
      <div class="no_show_message">
        <img src="@/assets/img/good/noGood.png" alt="努力加载中" />
        <!-- <div>努力加载中</div> -->
      </div>
    </div>
  </div>
</template>
<script>
import { getAccessToken } from '@/utils/userInfo'
import CountDown from '@/components/count-down'
import GoodPrice from '@/components/good-price'
// import { openOther } from '@/utils'
export default {
  data () {
    return {
      loading: false,
      spuLoading: false,
      spuInfo: null,
      attributeGroupList: [], // 参数项
      skuInfoList: [], // sku列表
      spuDetailInfo: '', // 商品详情
      count: 1,
      mainGraphIndex: 0, // 主图索引
      currentActive: null
    }
  },
  components: {
    CountDown,
    GoodPrice
  },
  computed: {
    spuId () {
      return this.$route.query.spuId
    },
    skuId () {
      return this.$route.query.skuId
    },
    currentSkuInfo () {
      let currentSku = {
        fileUrlList: []
      }
      let fileUrlList = this.spuInfo
        ? JSON.parse(JSON.stringify(this.spuInfo.fileUrlList)) || []
        : []
      if (
        this.skuId &&
        this.skuInfoList &&
        this.skuInfoList.length > 0 &&
        this.skuInfoList.findIndex(item => {
          return item.skuId === this.skuId
        }) > -1
      ) {
        currentSku = this.skuInfoList.find(item => {
          return item.skuId + '' === this.skuId + ''
        })
        if (currentSku) {
          if (currentSku.fileUrl) {
            fileUrlList.unshift(currentSku.fileUrl)
          }
          currentSku.fileUrlList = fileUrlList
        } else {
          currentSku = {
            fileUrlList: fileUrlList
          }
        }
      } else if (this.skuInfoList && this.skuInfoList.length > 0) {
        let minPrice = Math.min.apply(
          Math,
          this.skuInfoList.map(o => {
            return o.sellingPrice
          })
        )
        currentSku = this.skuInfoList.find(item => {
          return item.sellingPrice === minPrice
        })
        if (!currentSku) {
          currentSku = this.skuInfoList[0]
        }
        if (currentSku.fileUrl) {
          fileUrlList.unshift(currentSku.fileUrl)
        }
        currentSku.fileUrlList = fileUrlList
      } else {
        currentSku = {
          title: this.spuInfo ? this.spuInfo.name : '',
          tagPrice: 0,
          fileUrlList: fileUrlList
        }
      }
      return currentSku
    },
    // 库存数量
    stockCount () {
      let stockCount = 0
      if (
        this.currentActive &&
        (this.currentActive.promotionType === 1 ||
          this.currentActive.promotionType === 2)
      ) {
        // 总量
        let availableInventory =
          this.currentActive.promotionInfo.availableInventory || 0
        // 销售数量
        let saleInventory = this.currentActive.promotionInfo.saleInventory || 0
        stockCount = availableInventory - saleInventory
      }
      return stockCount > 0 ? stockCount : 0
    },
    showPrice () {
      let price = this.currentSkuInfo ? this.currentSkuInfo.sellingPrice : 0
      if (this.currentActive) {
        if (this.currentActive.promotionInfo) {
          price = this.currentActive.promotionInfo.promotionSalePrice
        }
      }
      return price
    }
  },
  watch: {
    spuId: {
      immediate: true,
      handler: 'getGoodInfo'
    },
    skuId (val) {
      this.count = 1
    }
  },
  filters: {
    formatAtt (att) {
      return att
        .map(item => {
          return item.name
        })
        .join('、')
    }
  },
  methods: {
    // 获取商品详情信息
    getGoodInfo () {
      if (!this.spuId) {
        return false
      }
      this.spuInfo = null
      this.attributeGroupList = []
      this.skuInfoList = []
      this.spuDetailInfo = ''
      this.spuLoading = true
      this.$request
        .get(`/front/punchout/commodity-user/spu-detail/${this.spuId}`)
        .then(res => {
          this.spuInfo = res.spuInfo
          this.attributeGroupList = res.attribute
            ? res.attribute.attributeGroupList || []
            : []
          this.skuInfoList = res.skuInfoList || []
          this.spuDetailInfo = res.spuDetailInfoForWeb || ''
        })
        .finally(() => {
          this.spuLoading = false
        })
    },
    // 更改主图的索引
    changeShowImg (index) {
      this.mainGraphIndex = index
    },
    // 更改当前选中的sku
    changeCurrentSku (item) {
      if (this.loading) {
        return false
      }
      this.mainGraphIndex = 0
      if (item.skuId + '' === this.skuId + '') {
        return false
      }
      this.$router.push({
        name: 'punchoutGoodsDetail',
        query: {
          spuId: this.spuId,
          skuId: item.skuId + '' === this.skuId + '' ? '' : item.skuId
        }
      })
    },
    // 立即购买
    buySku () {
      if (!this.currentSkuInfo || !this.currentSkuInfo.skuId) {
        this.$message.warning('请选择对应的型号')
        return false
      }
      // 未登录 跳转登录页
      if (!getAccessToken()) {
        this.$router.push({
          name: 'punchoutLogin'
        })
        return false
      }
      this.$router.push({
        name: 'punchoutSubmitOrder',
        query: {
          orderSource: '20',
          shoppingCart: JSON.stringify([{
            goodsSpuId: this.currentSkuInfo.spuId,
            goodsSkuId: this.currentSkuInfo.skuId,
            goodsNum: this.count
          }])
        }
      })
      return false
    },
    // 加入购物车
    addCart (shoppingType = '5') {
      if (!this.currentSkuInfo || !this.currentSkuInfo.skuId) {
        this.$message.warning('请选择对应的型号')
        return false
      }
      // 未登录 跳转登录页
      if (!getAccessToken()) {
        this.$router.push({
          name: 'punchoutLogin'
        })
        return false
      }
      if (this.loading) {
        return false
      }
      this.loading = true
      // 判断是否是企业站用户
      if (this.$store.state.user.corpUserInfo.customerId) {
        // 添加到企业站购物车
        this.$http.post(`/front/oms/crop-site/shopping-cart/add`,{
          custspId: this.currentSkuInfo.custspId,
          skuId: this.currentSkuInfo.skuId,
          goodsNum:  this.count,
        }).then(({ data: res }) => {
          if (res.code !== 0) {
            return false
          }
          this.bus.$emit('shopCartNum')
          this.$message.success('加入购物车成功')
        })
        .finally(() => {
          this.loading = false
        })
        return
      }
      this.$http.post(`/front/consumer/shoppingcart/addShoppingCart`, {
        goodsSpuId: this.spuId,
        goodsSkuId: this.currentSkuInfo.skuId,
        goodsNum: this.count,
        shoppingType: shoppingType
      })
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return false
          }
          this.bus.$emit('shopCartNum')
          this.$message.success(`加入购物车成功`)
        })
        .finally(() => {
          this.loading = false
        })
      // this.$router.push({
      //   name: 'punchoutShopCart',
      //   query: {}
      // })
      // return false
    },
    // 查看附件
    viewAttachment (url) {
      if (url) {
        window.open(url)
      }
    },
    brandHandle (brandId) {
      if (!brandId) {
        return false
      }
      this.$router.push({
        name: 'punchoutGoodsList',
        query: {
          brandId: brandId + '',
          listType: '2'
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.good_detail {
  background: #fff;
  padding-bottom: 30px;

  .good-flex {
    margin-top: 20px;
    line-height: 20px;
    // letter-spacing: 8px;
    display: flex;
    align-items: center;
    font-size: 14px;
    font-weight: 400;
    color: #555555;
    .lable {
      width: 80px;
      margin-right: 20px;
      padding-left: 20px;
      text-align: justify;
      text-align-last: justify;
    }
  }
  .detail_content {
    padding-top: 20px;
    .good_spku_info {
      margin-top: 20px;
      display: flex;
      justify-content: space-between;
      .good_info_imgs {
        width: 400px;
        .img-carousel {
          margin-top: 32px;
          // height: 60px;
          .imgs-row {
            width: 100%;
            height: 60px;
            padding-left: 20px;
            padding-right: 20px;
            .img_left {
              margin-left: 10px;
              cursor: pointer;
            }
          }
        }
        .good_sku_opt {
          margin-top: 21px;
          font-size: 16px;
          line-height: 22px;
          font-weight: 400;
          color: #555555;
        }
      }
      .good_info_content {
        margin-left: 10px;
        position: relative;
        padding-bottom: 100px;
        .good_title {
          width: 650px;
          font-size: 18px;
          font-weight: 600;
          color: #333333;
          line-height: 26px;
        }
        .good_dec {
          margin-top: 10px;
          margin-bottom: 20px;
          font-size: 16px;
          font-weight: 400;
          color: #d92a2a;
          line-height: 22px;
        }
        .good_original_price {
          margin-top: 0;
          height: 70px;
          background: #f5f5f5;
          /deep/ .price {
            color: #f63721;
            display: inline-block;
            .price-int {
              font-size: 26px;
            }
            .price-point {
              font-size: 14px;
            }
          }
          .original_price {
            font-size: 14px;
            font-weight: bold;
            color: #e64c3a;
            .cross_price {
              margin-left: 20px;
              font-size: 14px;
              font-weight: 400;
              text-decoration: line-through;
              text-align: left;
              color: #666666;
              line-height: 18px;
            }
          }
        }
        .good-models {
          .good-model {
            margin-top: 10px;
            display: inline-block;
            margin-right: 10px;
            border: 1px solid #dedede;
            padding: 5px 15px;
            color: #333333;
            font-weight: 400;
            font-size: 14px;
            cursor: pointer;
          }
          .good-model-choosed {
            border-color: #2e88ff;
          }
        }
        .bottom {
          position: absolute;
          bottom: 0;
          .good-opt {
            margin-left: 20px;
            color: #fff;
            .buy-imm {
              min-width: 150px;
              border: none;
              background: linear-gradient(132deg, #f97300 8%, #d9271e);
              color: #fff;
            }
            .buy-inquiry {
              min-width: 150px;
              border: none;
              background: #1d65a8;
              color: #fff;
              &:hover {
                background: #134574;
              }
            }
            // 禁用
            .but_ban {
              background: #aaa;
              cursor: not-allowed;
            }
            .add-cart {
              min-width: 150px;
              border: none;
              background: linear-gradient(233deg, #f47205 -22%, #f5b014 94%);
              color: #fff;
            }
          }
          .good-services {
            display: flex;
            .service {
              margin-right: 10px;
              font-size: 10px;
              .icon-color {
                color: #2e88ff;
              }
            }
          }
        }
      }
      .good_spu_detail {
        max-width: 100%;
        img {
          max-width: 100%;
        }
      }
      .group_params {
        border: 1px solid #eee;
        .model_params_name {
          padding: 12px 20px;
          font-size: 12px;
          line-height: 16px;
          color: #262727;
          font-weight: 500;
        }
        .attList {
          border-top: 1px solid #eee;
          display: flex;
          align-items: center;
          .att-name {
            padding: 10px;
            width: 30%;
            color: #999999;
            line-height: 16px;
            font-weight: 400;
            font-size: 12px;
            text-align: center;
            flex-shrink: 1;
            border-right: 1px solid #eee;
          }
          .att-value {
            padding-left: 10px;
            font-size: 12px;
            font-weight: 400;
            color: #666666;
            line-height: 16px;
          }
        }
      }
      .attachment {
        color: #2e88ff;
        cursor: pointer;
      }
    }
  }
  .home_page {
    height: 100%;
  }
}
</style>
